import { createContext, useContext } from 'react'
import type { AdminAccessView } from '@repo/shared'

/**
 * 로그인한 사람의 관리자 권한 (C52, GET /admin/me 의 access). 화면은 이것으로 메뉴·버튼을 숨기기만 하고,
 * 실제로 막는 것은 서버다(apps/api/src/lib/access-grants.ts). access 칸이 없는 옛 서버면 최고 관리자로 보고
 * 권한 관리 화면은 숨긴다 — 지금까지 화면 그대로
 */
export const OWNER_FALLBACK: AdminAccessView = { level: 'owner', grantsEnabled: false }

export const AdminAccessContext = createContext<AdminAccessView>(OWNER_FALLBACK)

export const useAdminAccess = () => useContext(AdminAccessContext)

/** 배정 운영자에게 보이는 화면 (서버 OPERATOR_ROUTES 가 허용하는 견적 화면뿐) */
const OPERATOR_PAGES: readonly string[] = ['/quotes']

/** 사이드바에 이 화면을 보일지. 운영자는 견적 화면만, 권한 관리는 최고 관리자에게 스위치가 켜졌을 때만 */
export function pageVisible(path: string, access: AdminAccessView): boolean {
  if (access.level === 'operator') return OPERATOR_PAGES.includes(path)
  return path !== '/access-grants' || access.grantsEnabled
}
